/* Swaps the main product image when the variant selector changes. */
(function () {
  function init() {
    var variantInput = document.getElementById('ultimate-selected-variant');
    var dataTag = document.querySelector('[data-type="product-variations-data"]');
    if (!variantInput || !dataTag) return;

    var variants;
    try { variants = JSON.parse(dataTag.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    function normalize(url) {
      if (!url) return null;
      if (url.indexOf('//') === 0) return 'https:' + url;
      return url;
    }

    function failed(el) {
      /* complete with zero natural width means the load finished without an image:
         either a real error, or an abort. While still downloading complete is
         false, so this never mistakes a slow load for a broken one. */
      return el.complete && el.naturalWidth === 0;
    }

    function retryOnce(src) {
      var el = document.getElementById('main-product-image');
      if (!el || el.getAttribute('src') !== src) return;
      if (!failed(el)) return;
      if (el.getAttribute('data-retried-src') === src) return;
      el.setAttribute('data-retried-src', src);
      el.removeAttribute('src');
      el.setAttribute('loading', 'eager');
      el.setAttribute('src', src);
    }

    function apply(src) {
      var mainImage = document.getElementById('main-product-image');
      if (!mainImage) return;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      /* Reassigning src on a loading="lazy" image the lazy loader has not processed
         yet issues no fetch at all, leaving it blank. Force eager first. */
      mainImage.setAttribute('loading', 'eager');
      if (mainImage.getAttribute('src') !== src) mainImage.setAttribute('src', src);
      /* product-item-zoom.js replaces this <img> node to build its magnifier, which
         can abort a download already in flight. Nothing fires a usable error event
         when that happens, so re-check after the fact and reload once if needed.
         Two checks cover slow connections; both no-op unless the load has settled. */
      setTimeout(function () { retryOnce(src); }, 1200);
      setTimeout(function () { retryOnce(src); }, 3500);
    }

    function swap() {
      var id = String(variantInput.value || '');
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === id) {
          var src = normalize(variants[i].featured_image);
          if (src) apply(src);
          return;
        }
      }
    }

    if (window.MutationObserver) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].type === 'attributes' && mutations[i].attributeName === 'value') {
            swap();
            return;
          }
        }
      }).observe(variantInput, { attributes: true });
    }

    variantInput.addEventListener('change', swap);

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.getAttribute && t.getAttribute('data-node-type') === 'add-to-cart-option-select') {
        setTimeout(swap, 60);
      }
    });

    document.addEventListener('click', function (e) {
      var t = e.target;
      while (t && t !== document) {
        if (t.getAttribute && t.getAttribute('data-node-type') === 'add-to-cart-option-pill') {
          setTimeout(swap, 60);
          return;
        }
        t = t.parentNode;
      }
    });

    swap();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
